import React from 'react';
const Loader = (props) => {
  if (props.pastDelay) {
    return <h2 className="h-100 text-center"></h2>
  } else {
    return null
  }
}
export default Loader;